import {
	isHideKbColumnEnabled,
	isTotalArticleCountEnabled,
	isVAOnHelpCenterGAEnabled,
} from '@helpcenter/feature-flags';
import { getMeta } from '@helpcenter/meta';
import type { RouterContext } from 'react-resource-router';
// eslint-disable-next-line no-restricted-imports
import { HelpHelpCenterAri } from '@atlassian/ari';
import { getJsmAIConfigEnabled } from '@atlassian/help-center-common-util/env';
import { createRelayResource } from '@atlassian/help-center-common-util/resource-router';
import type { srcHelpCenterVirtualAgentSettingsQuery } from './__generated__/srcHelpCenterVirtualAgentSettingsQuery.graphql';
import HelpCenterVirtualAgentSettingsQuery from './__generated__/srcHelpCenterVirtualAgentSettingsQuery.graphql';

export const HelpCenterVirtualAgentResource =
	createRelayResource<srcHelpCenterVirtualAgentSettingsQuery>({
		type: 'HELP_REPORTING_PAGE',
		getQuery: (
			{ match }: RouterContext,
			{ cloudId, helpCenterAri }: { cloudId: string; helpCenterAri: string },
		) => {
			let computedHelpCenterAri = helpCenterAri;
			const activationId = getMeta('activation-id') || '';
			const helpCenterId = match.params.helpcenterId || '';
			computedHelpCenterAri = HelpHelpCenterAri.create({ activationId, helpCenterId }).toString();

			// Fall back to original helpCenterAri if computation fails (e.g., missing params in tests)
			const finalHelpCenterAri = computedHelpCenterAri || helpCenterAri;
			return {
				parameters: HelpCenterVirtualAgentSettingsQuery,
				variables: {
					cloudId,
					helpCenterAri: finalHelpCenterAri,
					isJsmAIConfigEnabled: getJsmAIConfigEnabled(),
					isVAOnHelpCenterGAEnabled: isVAOnHelpCenterGAEnabled(),
					isHideKbColumnEnabled: isHideKbColumnEnabled(),
					isTotalArticleCountEnabled: isTotalArticleCountEnabled(),
				},
				options: {
					fetchPolicy: 'store-or-network',
				},
			};
		},
	});
